import axios from "axios"

const fetchEnv = async (retryCount = 0, maxRetries = 3) => {
  const path =
    process.env.NODE_ENV === "development"
      ? `${window.location.origin}/src/assets/config/config.json`
      : `${window.location.origin}/assets/config.json`

  try {
    const environnement = await axios({
      url: path,
      method: "get",
      timeout: 10000,
    })

    const { data } = environnement

    return data
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.error(error)

    // Try again, if not max retries
    if (retryCount < maxRetries) {
      const delay = Math.min(1000 * Math.pow(2, retryCount), 5000)
      await new Promise((resolve) => setTimeout(resolve, delay))
      return fetchEnv(retryCount + 1, maxRetries)
    }

    // Display an error message
    document.body.innerHTML = `
      <div class="w-full h-screen flex flex-col items-center justify-center text-center font-sans px-4">
        <h1 class="font-bold text-2xl mb-5">Connection Error</h1>
        <p class="text-base my-5 max-w-md">
          Unable to load the application after multiple attempts.<br />
          This might be due to a temporary network issue. Please check your connection and try again.
        </p>
        <button 
          onclick="window.location.reload()"
          class="bg-[#ff2f92] text-white border-none px-5 py-3 text-sm rounded-full cursor-pointer mt-5"
        >
          Reload Page
        </button>
      </div>
    `

    throw error
  }
}

export { fetchEnv }
